var _defs, _path, _path2, _path3, _circle, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesHub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1920,
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 344.47,
    y1: 825.51,
    x2: 1334.74,
    y2: 1555.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ff824e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ff5c35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 104.27,
    y1: 817.7,
    x2: 1860.91,
    y2: 817.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ff824e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ffa766"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1580,1488.63l-390.25-1201C1159.89,189,1068.34,117.2,960,117.2S760.11,189,730.27,287.59L340,1488.63A240,240,0,0,0,709.34,1757h0L960,1574.85,1210.65,1757l.18.11A240,240,0,0,0,1580,1488.63Z",
    fill: "#ff5c35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.72,1802.8A240,240,0,0,1,1210.65,1757L185.11,1011.86A240,240,0,0,1,467.25,623.53l1025.54,745.1a240,240,0,0,1-141.07,434.17Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1639.94,1057.7H326.18a240,240,0,1,1,0-480H1639.94a240,240,0,0,1,0,480Z",
    fill: "url(#b)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1639.94,
    cy: 817.7,
    r: 240,
    fill: "#ff5c35"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1920,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesHub);
export default __webpack_public_path__ + "static/media/SalesHub.1cf7ce2131c91ac6d479930e9b9a1c17.svg";
export { ForwardRef as ReactComponent };